import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactesService } from '../../services/contactes/contactes.service';
import { ListContactesService } from '../list.service';

import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'mcrit-gestio-contactes-filters',
  templateUrl: 'contactes-filters.component.html',
  styleUrls: ['contactes-filters.component.css'],
  providers: [ContactesService, ListContactesService]
})
export class ContactesFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, public languageService: LanguageService, private listContactesService: ListContactesService,private contactesService: ContactesService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listContactesService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listContactesService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listContactesService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    const newFilter = {};
    if(this.filterModel.length > -1)
        for (let key of this.filterModel) { newFilter[key] = null; }
    this.listContactesService.valFiltres={};
    this.filterModel = newFilter;
    this.sendActiveFilters();

  }

  ngOnInit() {

    let requestedAutocompletes = [];

      this.filterModel = this.validFilters.reduce((acum, curr) => {
          curr.inputs.forEach(inputGroup => {
            switch (inputGroup.type) {
              case 'select':
                acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
                break;
              default:
              inputGroup.values.forEach(input => {
                if (input.autocomplete) {
                  requestedAutocompletes.push(input.autocomplete);
                }
                acum[input.name] = (input.value ? input.value : null);
              });
            }
          });

        return acum;
      }, {});

      this.dataLists = requestedAutocompletes.map(id => {
        return {
          id: id,
          options: this.contactesService.getAutocomplete(id)
        };
      });
    this.sendActiveFilters();

  }

}
